<template>
  <div>
    <item v-for="(item, index) in elements"
          :key="index"
          :item="item"
          :index="index"
          :previousItem="previousItem"
          :nextItem="nextItem"
          v-on:active="active">
    </item>
  </div>
</template>

<script>
import Item from '@/components/Item'

export default {
  name: 'grid',
  props: ['items'],
  data () {
    return {
      elements: this.items,
      activeItem: null
    }
  },
  components: {
    'item': Item
  },
  computed: {
    previousItem () {
      return this.getPreviousItem(this.activeItem)
    },
    nextItem () {
      return this.getNextItem(this.activeItem)
    }
  },
  methods: {
    active (index) {
      this.activeItem = index
    },
    isItemDisabled (item) {
      return !item.name || (item.width !== item.height) || item.type === 'collection'
    },
    getPreviousItem (index) {
      let items = this.items.slice(0, index)
      for (let i = items.length - 1; i >= 0; i--) {
        if (!this.isItemDisabled(items[i])) {
          return i
        }
      }
    },
    getNextItem (index) {
      let items = this.items.slice(index + 1, this.items.length)
      let i = index + 1
      for (let j = 0; j < items.length; j++) {
        if (!this.isItemDisabled(items[j])) {
          return i
        }
        i += 1
      }
    }
  }
}
</script>

<style lang="scss">
@keyframes opacity {
  100% {
    opacity: 1;
  }
}

.grid {
  position: relative;
  z-index: 100;

  &.animation {
    opacity: 0;
    animation-name: opacity;
    animation-duration: 3.6s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }

  &.animation--delayed {
    animation-delay: 27s;
  }
}

.cta {
  padding-top: 28px;
  margin: 0 auto -500px;
  width: 775px;
  height: 525px;
  background-color: #f7f7f7;

  article {
    text-align: center;

    h2 {
      font-weight: 700;
      font-size: 40px;
      margin: 50px 70px;
      text-transform: uppercase;
      letter-spacing: 6.25px;
      line-height: 1.25;
    }

    h4{
      font-family: 'CorporateS', sans-serif;
      font-style: italic;
      font-weight: 400;
      font-size: 50px;
      transform: rotate(-15deg) translateX(-10px);
      display: inline-block;

      &:after {
        height: 3px;
        width: 100%;
        background: black;
        content: '';
        position: absolute;
        bottom: -6px;
        left: 0;
        margin-bottom: 5px;
      }
    }
  }

  .heart {
    width: 44px;
    height: 40px;
    display: block;
    margin: 0 auto;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDYgNDIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ2IDQyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6I0RDMEQxNTt9PC9zdHlsZT48cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTMuOSwxYy0zLjMsMC02LjYsMS4zLTkuMSwzLjljLTUsNS4yLTUsMTMuNywwLDE4LjlsMTcuMiwxNi43YzAuMywwLjMsMC43LDAuNSwxLjEsMC41YzAuNCwwLDAuOC0wLjEsMS4xLTAuNWwxNy4yLTE2LjdjMi41LTIuNiwzLjgtNiwzLjgtOS40YzAtMy40LTEuMy02LjktMy44LTkuNGMtMi4yLTIuMy01LjEtMy40LTguMS0zLjRjLTMuNiwwLTcuMywxLjYtMTAsNC4zTDIzLjEsNmMwLDAtMC4xLDAtMC4xLTAuMUMyMC4zLDMuNCwxNy4xLDEsMTMuOSwxTDEzLjksMXoiLz48L3N2Zz4=);
  }
}

#prototype06_hype_container > div {
  overflow: visible !important;
}
</style>



// WEBPACK FOOTER //
// Items.vue?3b078449